<section>
    <table class="tabla" id="tabla">

        <tbody id="myTable">

        <div *ngFor="let name of strClimaLocalidad; let i =index" class="divTr">
            
            <tr class="tr">
                
                    <td><h2><span class="titulo2">{{ strClimaLocalidad[i]?.name }}</span> <span class="diminuir">- {{ strClimaLocalidad[i]?.province }}</span></h2></td>
                    
                    <ng-template #ocultarBoton>
                        <td>
                                
                            <button mat-raised-button color="primary" (click)="clickMostrar(i)" alt="Ver Detalles del Clima" matTooltip="hacé click para ver los detalles del clima" [matTooltipShowDelay]="0" [matTooltipHideDelay]="1000">           
                                Ver Detalles del Clima
                            </button>
                            
                        </td>
                    </ng-template>
                    
                    <div *ngIf="posicionLocalidad == i; then mostrarValores;else ocultarBoton"></div>
                    
                    <ng-template #mostrarValores>
                        <td>
        
                                <app-autocompletar (hijoEvento)="posicionLocalidad=$event" [strClimaLocalidad]= strClimaLocalidad [posicionLocalidad]=posicionLocalidad ></app-autocompletar>
                            
                        </td>
                    </ng-template>
            </tr>
        </div>

        </tbody>
        <button mat-fab color="accent" aria-label="Volver arriba" (click)="topFunction()" class="boton">
            <i class="fas fa-level-up-alt"></i>
        </button>
    </table>
</section>
